import * as React from "react";
import styled from "styled-components";
import { FormInput } from "./FormInput";
import { useForm, ValidationError } from "@formspree/react";

export function ContactForm() {
  const formInputs = [
    { id: "name", label: "Your Name", type: "text" },
    { id: "email", label: "Your Email Address", type: "email" },
    { id: "message", label: "Your Message...", type: "textarea" },
  ];

  const [state, handleSubmit] = useForm("xoqbgjjn");
  if (state.succeeded) {
    return <FormAlert>Thanks, we will contact you soon!</FormAlert>;
  }

  return (
    <FormContainer>
      <FormWrapper onSubmit={handleSubmit}>
        <FormTitle>
          Get Your Free Direct Sales Strategy Quote
        </FormTitle>
        {formInputs.map((input) => (
          <FormInput key={input.id} {...input} />
        ))}
        <SubmitButton type="submit">Start Selling Direct!</SubmitButton>
      </FormWrapper>
    </FormContainer>
  );
}

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  line-height: normal;
  width: 50%;
  margin-left: 20px;
  @media (max-width: 991px) {
    width: 100%;
  }
`;

const FormWrapper = styled.form`
  border-radius: var(--border-radius);
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  display: flex;
  width: 100%;
  flex-direction: column;
  color: var(--light-text);
  margin: 13px auto 0;
  padding: 58px 45px 80px;
  font: 400 16px/1.6 'Manrope', sans-serif;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;
  overflow: hidden;
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 5px;
    background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
    z-index: 1;
  }
  
  @media (max-width: 991px) {
    max-width: 100%;
    margin-top: 40px;
    padding: 40px 25px 60px;
  }
  
  @media (max-width: 500px) {
    padding: 30px 20px 50px;
    margin-left: -10px;
  }
`;

const FormTitle = styled.h2`
  color: #ffffff;
  text-align: center;
  align-self: center;
  font: 700 26px/1.3 'Manrope', sans-serif;
  margin-bottom: 30px;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: linear-gradient(90deg, var(--accent-color), var(--secondary-color));
    border-radius: 3px;
  }
  
  @media (max-width: 500px) {
    font-size: 22px;
    max-width: 280px;
    margin-left: auto;
    margin-right: auto;
  }
`;

const SubmitButton = styled.button`
  border-radius: 10px;
  background: var(--button-gradient);
  margin-top: 30px;
  min-height: 61px;
  font-size: 16px;
  color: #ffffff;
  font-weight: 700;
  text-align: center;
  line-height: 1;
  padding: 22px 40px;
  border: none;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  }
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
    );
    transition: 0.5s;
  }
  
  &:hover:before {
    left: 100%;
  }
  
  @media (max-width: 991px) {
    padding: 20px;
  }
`;

const FormAlert = styled.p`
  font-size: 1.8em;
  font-weight: bold;
  color: white;
  margin: auto;
  background: linear-gradient(135deg, rgba(142, 249, 76, 0.8), rgba(107, 201, 49, 0.8));
  padding: 1.5em;
  border-radius: 15px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  text-align: center;
`;
